import { Component, OnInit } from '@angular/core';
import { GotovinskiKomitent } from './gotovinski-komitent';
import { ModalContainerService, ModalService, BaseDataService, BaseContainerService, BaseModalContainer, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-gotovinski-komitent',
  templateUrl: './gotovinski-komitent.component.html'
})
export class GotovinskiKomitentComponent
 extends BaseModalContainer<GotovinskiKomitent>
  implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<GotovinskiKomitent>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }


  ngOnInit() {
  }

}
